import { useEffect, useMemo } from 'react';
import useIsMobileDevice from '@/hooks/useIsMobileDevice';
import { useShallShowAds } from '@/hooks/useShallShowAds';
import styles from './index.module.scss';

const FIRST_SLOTNAME_DESKTOP = '007-CONTENTBOARD';
const FIRST_SLOTNAME_MOBILE = '104-RECTANGLE-MOBI';
const BASE_SLOTNAME_DESKTOP = '011-MIDBOARD';
const BASE_SLOTNAME_MOBILE = '011-MIDBOARD-MOBI';

export default function Ad ({ adsIndex }: { adsIndex: number }) {
  const { isMobile } = useIsMobileDevice();
  const { shallShowAds } = useShallShowAds();
  const slotName = useMemo(() => {
    if (isMobile) {
      return adsIndex !== 1 ? BASE_SLOTNAME_MOBILE : FIRST_SLOTNAME_MOBILE;
    } else {
      return adsIndex !== 1 ? BASE_SLOTNAME_DESKTOP : FIRST_SLOTNAME_DESKTOP;
    }
  }, [isMobile, adsIndex]);
  const slotDivId = useMemo(() => `DFP-${slotName}_${adsIndex}`, [slotName, adsIndex]);
  const slotClassName = useMemo(() => `DFP-${slotName}`, [slotName]);

  useEffect(() => {
    if (!shallShowAds || !globalThis.putBanDFPInViewObject) {
      return;
    }

    if (slotName !== FIRST_SLOTNAME_DESKTOP && slotName !== FIRST_SLOTNAME_MOBILE) {
      globalThis.putBanDFPInViewObject({
        divId: slotDivId,
        slot: slotName,
      });
    } else if (globalThis.putBanDFP) {
      globalThis.putBanDFP(slotName, slotDivId);
    }

    return () => {
      if (!globalThis.googletag) {
        return;
      }

      globalThis.googletag
        .pubads()
        .getSlots()
        .forEach(function (slot) {
          if (slot.getSlotElementId() === slotDivId) {
            console.info('Reset slot:', slotDivId);
            globalThis.googletag.destroySlots([slot]);
          }
        });
    };
  }, [shallShowAds, slotDivId, slotName]);

  return (
    <div className={styles['ad-wrapper']}>
      <div
        className={['adviewDFPBanner', slotClassName].join(' ')}
        data-e={`notes-ad-wrapper-${slotName}`}
        id={slotDivId}
      />
    </div>
  );
}
